<script setup lang="ts">
import { Integration } from '@/modules/dashboard/integrations/store/useIntegrationStore';
import { Button } from '@/storybook';

interface Props {
  integration: Integration;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  toggle: [];
  requestEnable: [name: string];
}>();

const getButtonType = () => {
  if (props.integration.requiresRequest) {
    return 'ghost';
  }

  return props.integration.enabled ? 'solid' : 'ghost';
};

const getButtonVariant = () => {
  if (props.integration.requiresRequest) {
    return 'gray';
  }

  return props.integration.enabled ? 'green' : 'black';
};

const getButtonText = () => {
  if (props.integration.requiresRequest) {
    return 'Request to enable';
  }

  return props.integration.enabled ? 'Manage' : 'Enable';
};

const handleClick = () => {
  if (props.integration.requiresRequest) {
    emit('requestEnable', props.integration.name);
  } else {
    emit('toggle');
  }
};
</script>

<template>
  <Button
    :type="getButtonType()"
    :variant="getButtonVariant()"
    :data-testid="`integration-button-${props.integration.name.toLowerCase()}`"
    @click.prevent="handleClick"
  >
    {{ getButtonText() }}
  </Button>
</template>
